export const appMarketList = [
  {
    icon: "app-store",
    qrcode: require("@/assets/images/newImg/qrcode-box.png")
  },
  {
    icon: "test-flight",
    link: ""
  },
  {
    icon: "google-play",
    link: ""
  },
  {
    icon: "android-apk",
    link: ""
  }
];



// WEBPACK FOOTER //
// ./src/data/download.js